import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { DateFormatHelper } from '../../../../_helpers/date-format-helper';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared.module';
import { ICONS } from '../../../../_helpers/icons.constants';
import { TextboxComponent } from 'src/app/shared/design-system/textbox/textbox.component';
import { TextboxConfig } from 'src/app/shared/design-system/textbox/textbox.modal';

@Component({
  selector: 'formly-date-formats',
  templateUrl: "./formly-date-format.component.html",
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule, FormlyModule, SharedModule, TextboxComponent]
})
export class FormlyDateFormatsComponent extends FieldType implements OnInit, OnDestroy {
  constructor(private dynamicFormService: DynamicFormService, private translate: TranslateService) {
    super();
  }
  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  fieldKey: string;
  searchText: string;
  dateFormats = DateFormatHelper.getAllDateFormatsWithDefault(true);
  selectedDate: string = "";
  public ICONS = ICONS;
  textboxConfig: TextboxConfig = {
    id: 'searchText',
    label: this.translate.instant("label_search_criterion"),
    iconSrc: ICONS.SEARCH,
    iconPosition: 'right',
    size: 'md',
  };
  

  ngOnInit() {
    if (this.field.key) {
      this.fieldKey = this.field.id ?? this.field.key.toString();
    }
    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });

    this.fnGetSelectedFormatOnTop();
    this.textboxConfig = {
      ...this.textboxConfig,
    }
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
  }

  fnSetDateFormat(item) {
    this.formControl.setValue(item);
    if (this.to.click) {
      this.to.click(this, item);
    }
  }

  fnGetSelectedFormatOnTop() {
    if (this.formControl?.value) {
      let selectedFormat = this.formControl.value;
      const sortedArr = this.dateFormats.reduce((acc, element) => {
        if (element == selectedFormat) {
          return [element, ...acc];
        }
        return [...acc, element];
      }, []);
      this.dateFormats = sortedArr;
    }
  }

}